import Keycloak from "keycloak-js";
import { SET_AUTH, SET_USER } from "./actionTypes";
import { setUser} from "./user";
import { fetchJobNames, fetchTimecardWeeks, fetchEmployeeDetails} from  "./../actions";

export const setAuth = (auth) =>
 ({
    type: SET_AUTH,
     auth
  });


export const authUser = () =>async(dispatch)=>{
   const keycloak = Keycloak("/clientApproval/keycloak.json");
  try{
    return keycloak.init({ onLoad: "login-required" }).success(authenticated => {
      dispatch(setAuth({ keycloak: keycloak, authenticated: authenticated }));
      return  keycloak.loadUserInfo().success(userInfo => {
        console.log(userInfo)
              dispatch(({
                type: SET_USER,
                user:userInfo
            }));
            dispatch(fetchJobNames(userInfo.clientID))
            dispatch(fetchTimecardWeeks(userInfo.clientID))
            dispatch(fetchEmployeeDetails({  
              "offset": "1",
              "size": "50",
              "sortingColumn": "timecardWeekStartDate",
              "sortingType": "DESC",
              "supervisorId": userInfo.clientID,
              "timecardWeekId": "",
              "employeeName": "",
              "jobId": "",
            }))
             
            })
          })
  }catch(e){
    console.log(e)
  }
  
  
}
